/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setDrawerButton } from "./setDrawerButton";
import { setSwiper } from "./setSwiper";
import { tabSelecterClick } from "./setTabSelecter";
import { setHeaderTransform } from "./setHeaderTransform";
import { setSplash } from "./setSplash";
import { setScrollTrigger } from "./setScrollTrigger";

/**
 * Add modle.
 */
function addModle() {
  const partnerEvent = () => {
    const partnerSlider = document.querySelector(".partner__slider");
    const partnerSliderItem = document.querySelectorAll('.partner__list-item');
    const partnerSliderPlayState = (state) => partnerSlider.style.animationPlayState = state;
    const partnerSliderPlayStateAction = (el) => {
      if (window.matchMedia("(pointer: coarse)").matches) {
        el.addEventListener("touchstart", () => partnerSliderPlayState("paused"));
        el.addEventListener("touchend", () => partnerSliderPlayState("running"));
      } else {
        el.addEventListener("mouseenter", () => partnerSliderPlayState("paused"));
        el.addEventListener("mouseleave", () => partnerSliderPlayState("running"));
      }
    }
    partnerSliderItem.forEach((item) => partnerSliderPlayStateAction(item));
    partnerSliderPlayStateAction(partnerSlider);
  }

  window.document.body.classList.contains("home") && partnerEvent();
}

/**
 * Do modules.
 */
function modules() {
  setDrawerButton();
  setSwiper();
  tabSelecterClick();
  setHeaderTransform();
  setSplash();
  addModle();
  setScrollTrigger();
}

export { modules };
